import React from 'react';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';

function FacebookComponent () {
    const handleClick = () => {
        const url = `https://www.facebook.com/BillyGymAcademia/`;
        window.open(url, '_blank');
    };
    
    return (
        <IconButton onClick={handleClick}>
            <FacebookIcon sx={{color:"#ffea00"}} />
        </IconButton>
    );
};
export default FacebookComponent;